import React, { useState, useEffect } from 'react';
import { FiInstagram, FiYoutube, FiLinkedin, FiTwitter, FiFacebook } from 'react-icons/fi';
import styles from "../../assets/scss/WebHomePagesscss/WebFooter.module.scss";
import Logo from '../../assets/images/cropLogo.png';

const WebFooter = () => {
  const sections = ["features", "Freemium", "download", "contact",];
  const [activeSection, setActiveSection] = useState("home");

  // const scrollToSection = (id) => {
  //   const element = document.getElementById(id);
  //   if (element) {
  //     element.scrollIntoView({ behavior: "smooth" });
  //     setActiveSection(id);
  //   }
  // };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = document.querySelector("header")?.offsetHeight || 100;
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      setActiveSection(id);
    }
  };


  // Scroll spy to update active link
  useEffect(() => {
    const handleScroll = () => {
      let current = activeSection;
      sections.forEach((section) => {
        const elem = document.getElementById(section);
        if (elem) {
          const top = elem.getBoundingClientRect().top;
          if (top <= 100) current = section; // offset for sticky header
        }
      });
      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeSection]);

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        {/* Logo and Social Media Section */}
        <div className={styles.logoSection}>
          <div className={styles.logo}>
            <div className={styles.logoIcon}>
              <img
                src={Logo}
                alt="logo"
                className={styles.logo}
              />
            </div>
          </div>

          <div className={styles.socialIcons}>
            <a href="#" className={styles.socialLink} aria-label="Instagram">
              <FiInstagram />
            </a>
            <a href="#" className={styles.socialLink} aria-label="YouTube">
              <FiYoutube />
            </a>
            <a href="#" className={styles.socialLink} aria-label="LinkedIn">
              <FiLinkedin />
            </a>
            <a href="#" className={styles.socialLink} aria-label="Twitter">
              <FiTwitter />
            </a>
            <a href="#" className={styles.socialLink} aria-label="Facebook">
              <FiFacebook />
            </a>
          </div>
        </div>

        {/* Quick Links Section */}
        <div className={styles.linksSection}>
          <h3 className={styles.linksTitle}>Quick Links</h3>
          <nav className={styles.navLinks}>
            {sections.map((sec) => (
              <button
                key={sec}
                onClick={() => scrollToSection(sec)}
                className={activeSection === sec ? styles.activeLink : styles.navLink}
              >
                {sec.charAt(0).toUpperCase() + sec.slice(1)}
              </button>
            ))}
          </nav>
        </div>
          



      </div>
      <div className={styles.footerBottom}>
            <p className={styles.margin}>
            Copyright   © {new Date().getFullYear()} <strong>PAA Crop Work Solution LLP</strong>. All rights reserved.
            </p>
          </div>
    </footer>
  );
};

export default WebFooter;
